/*
 * Copyright © 2026, CodeVision. All rights reserved.
 * 
 * This file was generated by Codevision's stub generator
 */ 

import { VehicleType } from './vehicleType';
import { ReservationState } from './reservationState';
import { ServiceType } from './serviceType';

export class WorkReservationDisplayModel {

    workStationId: number;
    plateNumber: string;
    vehicleType: VehicleType;
    note: string;
    reservationState: ReservationState;
    ownReservation: boolean;
    serviceType: ServiceType;
    extraServiceName: string;
    referenceId: string;
    startDateTime: Date;

    constructor() {

    }


}
